import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/")({
	beforeLoad: () => {
		throw redirect({ to: "/recruit-positions" });
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <div>選考基準一覧にリダイレクトされます</div>;
}
